/* Buck the Stigma — shop carousel + mobile menu.
   Written to survive Shopify theme-editor section reloads. */
(function () {
  'use strict';

  /* ---------- mobile menu ---------- */
  function initHeader(root) {
    var burger = root.querySelector('[data-bts-burger]');
    var drawer = root.querySelector('[data-bts-drawer]');
    if (!burger || !drawer || burger.dataset.btsReady) return;
    burger.dataset.btsReady = '1';
    burger.addEventListener('click', function () {
      var open = drawer.dataset.open === 'true';
      drawer.dataset.open = String(!open);
      burger.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---------- shop carousel ---------- */
  function initShop(root) {
    var section = root.querySelector('.bts-shop') || (root.classList && root.classList.contains('bts-shop') ? root : null);
    if (!section || section.dataset.btsReady) return;
    section.dataset.btsReady = '1';

    var picker = section.querySelector('[data-bts-picker]');
    var pickerBtn = section.querySelector('[data-bts-picker-btn]');
    var pickerList = section.querySelector('[data-bts-picker-list]');
    var label = section.querySelector('[data-bts-picker-label]');
    var count = section.querySelector('[data-bts-picker-count]');
    var shopAll = section.querySelector('[data-bts-shopall]');
    var prev = section.querySelector('[data-bts-prev]');
    var next = section.querySelector('[data-bts-next]');
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-bts-panel]'));
    if (!panels.length || !picker) return;

    var active = 0;

    function currentPanel() { return panels[active]; }

    function updateArrows() {
      var t = currentPanel();
      if (!t || !prev || !next) return;
      var max = t.scrollWidth - t.clientWidth - 2;
      prev.disabled = t.scrollLeft <= 2;
      next.disabled = t.scrollLeft >= max;
    }

    function select(i) {
      active = i;
      panels.forEach(function (p, n) { p.dataset.active = String(n === i); });
      var btn = pickerList.querySelectorAll('button')[i];
      if (btn) {
        if (label) label.textContent = btn.dataset.name || '';
        if (count) count.textContent = (btn.dataset.count || '0') + ' items';
        if (shopAll) {
          shopAll.href = btn.dataset.url || '#';
          shopAll.textContent = 'Shop all ' + (btn.dataset.name || '').toLowerCase() + ' \u2192';
        }
      }
      pickerList.querySelectorAll('button').forEach(function (b, n) {
        b.setAttribute('aria-current', String(n === i));
        if (b.parentNode) b.parentNode.setAttribute('aria-selected', String(n === i));
      });
      var t = currentPanel();
      if (t) t.scrollTo({ left: 0, behavior: 'auto' });
      requestAnimationFrame(updateArrows);
    }

    function step(dir) {
      var t = currentPanel();
      if (!t) return;
      var card = t.querySelector('.bts-card');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(t).gap) || 22;
      t.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
    }

    function closePicker() {
      picker.dataset.open = 'false';
      if (pickerBtn) pickerBtn.setAttribute('aria-expanded', 'false');
    }

    if (pickerBtn) {
      pickerBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = picker.dataset.open === 'true';
        picker.dataset.open = String(!open);
        pickerBtn.setAttribute('aria-expanded', String(!open));
      });
    }
    pickerList.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      select(parseInt(b.dataset.i, 10) || 0);
      closePicker();
    });
    document.addEventListener('click', function (e) {
      if (!picker.contains(e.target)) closePicker();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePicker();
    });

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    panels.forEach(function (p) { p.addEventListener('scroll', updateArrows, { passive: true }); });
    window.addEventListener('resize', updateArrows);

    select(0);
  }

  function initAll(scope) {
    var root = scope || document;
    initHeader(root);
    initShop(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
